module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['form-group', 'row', _vm.inputState]
  }, [(_vm.label) ? _c('label', {
    class: ['col-form-label', _vm.labelLayout, _vm.labelAlignClass],
    attrs: {
      "for": _vm.target
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "content",
    class: _vm.inputLayout
  }, [_vm._t("default"), _vm._v(" "), (_vm.feedback) ? _c('div', {
    staticClass: "form-text form-control-feedback",
    attrs: {
      "role": "alert",
      "aria-live": "polite"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.feedback)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.description) ? _c('small', {
    staticClass: "form-text text-muted",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfa3267c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/form-fieldset.vue
// module id = 258
// module chunks = 0